import { render, staticRenderFns } from "./AfiliadosPage.vue?vue&type=template&id=17b6a36f&"
import script from "./AfiliadosPage.vue?vue&type=script&lang=js&"
export * from "./AfiliadosPage.vue?vue&type=script&lang=js&"
import style0 from "./AfiliadosPage.vue?vue&type=style&index=0&id=17b6a36f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports